import styled from "styled-components";
import { COLORS } from "styles/colors";
import { FLEX } from "styles/flex";
import * as mediaQuery from "components/MediaQuery";
import { calcRem } from "styles/theme";

export const EmptyContainer = styled.div`
  background-color: ${({ theme }) => theme.COLORS.WIDGETCOLOR};
  border-radius: 5px;
  ${FLEX.FlexCenterCenter};
  flex-direction: column;
  width: 100%;
  padding: 100px 0;
  gap: 20px;
  color: ${({ theme }) =>
    theme.value === "light" ? COLORS.BLACK : COLORS.WHITE}60;
  text-align: center;
  b {
    display: block;
    padding-bottom: 15px;
    font-weight: 600;
  }
`;

export const InfoWrapper = styled.div`
  ${FLEX.FlexStartCenter};
  width: 100%;
  gap: 6px;
  padding-bottom: 10px;
  color: ${({ theme }) => theme.COLORS.WHITE}60;
  svg {
    width: 16px;
    height: 16px;
  }
  rect {
    fill: none;
  }
  path {
    fill: currentColor !important;
  }
`;

export const Title = styled.div`
  width: 100%;
  padding-bottom: 20px;
  ${FLEX.FlexBetweenCenter};
  h2 {
    color: ${({ theme }) => theme.COLORS.WHITE};
    font-size: ${calcRem(24)};
    font-weight: 600;
  }
  ${mediaQuery.isMobile} {
    padding: 10px 0;
  }
`;

export const ValueWrapper = styled.div`
  ${FLEX.FlexStartStart};
  width: 100%;
  gap: 10px;
  input {
    width: 100%;
    height: 40px;
  }
  .common-modal-input {
    padding-bottom: 0;
  }
`;

export const AddButton = styled.button`
  ${FLEX.FlexCenterCenter};
  background-color: transparent;
  border: none;
  padding: 6px;
  color: ${({ theme }) => theme.COLORS.WHITE};
  &:hover {
    background-color: ${({ theme }) => theme.COLORS.BORDER};
    border-radius: 3px;
  }
`;

export const DeleteButton = styled.button<{ index: number }>`
  margin-top: ${({ index }) => (index === 0 ? "30px" : "10px")};
  padding: 5px;
  height: 40px;
  ${FLEX.FlexCenterCenter};
  color: ${({ theme }) => theme.COLORS.BUTTONS2};
  svg {
    display: block;
  }
`;

export const Item = styled.div`
  width: 100%;
  color: ${({ theme }) =>
    theme.value === "light" ? COLORS.BLACK : COLORS.WHITE}60;
  ${FLEX.FlexCenterCenter};
  flex-direction: column;
  h3 {
    ${FLEX.FlexBetweenCenter};
    width: 100%;
    border-bottom: 1px solid ${({ theme }) => theme.COLORS.BORDER};
    padding-bottom: 3px;
    color: ${({ theme }) =>
      theme.value === "light" ? COLORS.BLACK : COLORS.WHITE};
    label {
      font-size: ${calcRem(16)};
      font-weight: 600;
    }
    button {
      ${FLEX.FlexCenterCenter};
      background-color: transparent;
      border: none;
    }
  }
  > p {
    width: 100%;
    padding: 10px 0;
    font-size: ${calcRem(14)};
  }
`;
export const ButtonWrapper = styled.div`
  ${FLEX.FlexCenterCenter};
  width: 100%;
  gap: 10px;
`;
